import React, { useState, useRef, useEffect } from "react";
import { Autocomplete } from "@react-google-maps/api";

import { alpha3ToAlpha2 } from "i18n-iso-countries";
import _ from "lodash";

import { useDispatch, useSelector } from "react-redux";

import ReactCountryFlag from 'react-country-flag';

import actions from "../../../../redux/actions";
import { usePosition } from '../../../../hooks/use-position';
import localesReplacement from '../../../../utils/localesReplacement';
import {
  ENABLED_LOCATION_PHOTO_COUNTRIES,
  GOOGLE_AUTOCOMPLETE_TYPES,
  GOOGLE_AUTOCOMPLETE_FIELDS
} from '../../../../constants';

import styles from "./index.module.scss";


const LocationSearch = () => {
  const country = useSelector((state: any) => state.country);

  const countryAlpha2 = alpha3ToAlpha2(country.isoCode ?? "GBR") ?? "gb";

  const [ countryForFlag, setCountryForFlag ] = useState<string>(countryAlpha2);

  const dispatch = useDispatch();

  const [searchBox, setSearchBox] = useState<google.maps.places.Autocomplete>();

  const [img, setImg] = useState<string>('');

  const [location, setLocation] = useState<any>();

  const replacements = useSelector((state: any) => state.replacements);

  const photoEnabled = ENABLED_LOCATION_PHOTO_COUNTRIES.includes(country.isoCode ?? '');

  const [ position ] = usePosition(undefined, replacements);

  useEffect(() => {
    if (position && 'name' in position && position.name) {
      setLocation(position.name);
    }
  }, [position]);


  const onPlacesChanged = () => {
    if (searchBox) {
      const place = searchBox.getPlace();
      if ("formatted_address" in place) {
        setLocation(place.formatted_address);
        const { setAddress } = actions;
        if (countryAlpha2 === 'GB') {
          setCountryForFlag(place?.formatted_address?.endsWith('Ireland') ? 'IE' : 'GB');
        }
        dispatch(
          setAddress({
            name: place.name,
            coordinate: {
              lat: (place?.geometry?.location?.lat() as unknown as number) ?? 0,
              lng: (place?.geometry?.location?.lng() as unknown as number) ?? 0
            }
          })
        );
      }
    }
  };

  const onLoad = (ref: google.maps.places.Autocomplete) => {
    setSearchBox(ref);
  };

  return (
    <div className={styles.container}>
      <div className="label"> {localesReplacement(replacements, "Search address")} </div>
      <div className={styles.wrapper}>
        <div className={styles.image}>
          <ReactCountryFlag
            style={{
              width: "auto",
              height: "auto",
            }}
            svg
            countryCode={countryForFlag}
          />
        </div>
        <Autocomplete
          restrictions={{
            country: [countryAlpha2].concat(countryAlpha2 === 'GB' ? ['IE'] : []),
          }}
          onPlaceChanged={onPlacesChanged}
          onLoad={onLoad}
          options={{
            types: GOOGLE_AUTOCOMPLETE_TYPES,
            fields: GOOGLE_AUTOCOMPLETE_FIELDS.concat(photoEnabled ? 'photos' : [])
          }}
        >
          <input
            placeholder={localesReplacement(replacements, "Enter your postcode or address")}
            value={location}
            className={styles.input}
            onChange={(evt) => setLocation(evt.target.value)}
          />
        </Autocomplete>
        { photoEnabled && img && (
            <img src={img}/>
        )}
      </div>
    </div>
  );
};

export default LocationSearch;
